import { useEffect, useRef } from 'react';

function useDebouncedEffect(callback, deps, delay = 300) {
  const controllerRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    controllerRef.current?.abort();
    controllerRef.current = new AbortController();
    const signal = controllerRef.current.signal;

    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      if (!signal.aborted) {
        callback(signal);
      }
    }, delay);

    return () => {
      controllerRef.current?.abort();
      clearTimeout(timeoutRef.current);
    };
  }, [...deps, delay]);
}

export default useDebouncedEffect;
